// Cuadre de un pago/cobro bancario contra el CONJUNTO de cuotas que amortiza.
//
// Parametrizado por un conjunto de cuotas a propósito: hoy el modal vincula UNA sola cuota, pero el
// bloque 1.4 (un pago que amortiza una cuota de cada factura — ej. Blackim $1.656.034 = $1.130.440 +
// $525.593) reusa esta misma función pasando las N cuotas, sin re-trabajo (10.103).
//
// La comparación asume que `montoMovComparable` y los montos que devuelve `montoDe(cuota)` están en la
// MISMA moneda: el llamador se encarga de convertir con convertirAMonedaLocal si el movimiento y las
// cuotas están en monedas distintas (10.185). El helper es puro (no toca DB ni moneda), para poder
// testear el cuadre en aislamiento.
//
// La tolerancia absorbe SOLO redondeo (nunca un %): al partir un total en cuotas iguales queda un
// resto de ~$1 por cuota (última cuota lleva la diferencia — ver 1143/1139). El llamador la escala por
// la cantidad de cuotas. Un descuadre real (monto equivocado) queda MUY por encima de esa tolerancia.
//
// Devuelve:
//   - sumaCuotas: Σ de los montos de las cuotas (en la moneda de comparación).
//   - diferencia: montoMovComparable − sumaCuotas, CON signo (>0 el movimiento excede; <0 no cubre).
//   - cuadra: |diferencia| ≤ |tolerancia|.
export const evaluarCuadreCuotas = (
  cuotas,
  montoMovComparable,
  tolerancia,
  montoDe = (c) => Math.abs(Number(c?.monto_cuota || 0))
) => {
  const sumaCuotas = (cuotas || []).reduce((s, c) => s + montoDe(c), 0);
  const diferencia = Number(montoMovComparable || 0) - sumaCuotas;
  return { sumaCuotas, diferencia, cuadra: Math.abs(diferencia) <= Math.abs(Number(tolerancia || 0)) };
};
